import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

(function () {
  const pluginNamespace = {
    init() {
      console.log("Plugin initialized");

      ReactDOM.createRoot(
        document.getElementById("bf-shopping-assistant")
      ).render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    },
  };

  // Expose the namespace to the global scope if needed
  window.pluginNamespace = pluginNamespace;

  // Call the initialization function
  pluginNamespace.init();
})();
